import React, { useState } from "react";
import Footer from "../components/Footer";
import { Col, Container, Row, Form, Button, Alert } from "react-bootstrap";
import Navegacion from "../components/BarraNavegacion";
import CardMisCodigos from "../components/CardsCodigos";
import { db } from "../firebase-config";
import { collection, getDocs, query, where } from "firebase/firestore";

function MisCodigos() {
  const [validated, setValidated] = useState(false);
  const [email, setEmail] = useState("");
  const [compras, setCompras] = useState([]);
  const [error, setError] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
  
    if (!form.checkValidity()) {
      event.stopPropagation();
      return;
    }
  
    try {
      setError(null);
      setCompras([]);
  
      // ✅ Consultar todos los sorteos activos
      const sorteosRef = collection(db, "sorteos");
      const sorteosSnapshot = await getDocs(sorteosRef);
  
      if (sorteosSnapshot.empty) {
        setError("No hay sorteos en la base de datos.");
        return;
      }
  
      // 🏆 Consultar todos los tickets en paralelo
      const promesas = sorteosSnapshot.docs.map(async (sorteoDoc) => {
        const sorteoId = sorteoDoc.id;
        const sorteoData = sorteoDoc.data();
  
        // Consultar tickets del usuario en este sorteo
        const ticketsRef = collection(db, "sorteos", sorteoId, "tickets");
        const ticketsQuery = query(ticketsRef, where("usuario", "==", email));
        const ticketsSnapshot = await getDocs(ticketsQuery);
  
  
        if (!ticketsSnapshot.empty) {
          const tickets = ticketsSnapshot.docs.map((doc) => ({
            id: doc.id,
            numero: doc.data().numero,
            fecha:
              doc.data()?.timestamp?.toDate()?.toLocaleDateString() ||
              "Fecha no disponible",
          }));
  
          return {
            sorteoId,
            sorteo: sorteoData,
            tickets,
          };
        }
        return null;
      });
  
      const comprasUsuario = (await Promise.all(promesas)).filter(Boolean);
  
      if (comprasUsuario.length === 0) {
        setError("No se encontraron compras asociadas a este correo.");
        return;
      }
      setCompras(comprasUsuario);
    } catch (err) {
      setError("Error al consultar los datos. Inténtalo de nuevo.");
    }
  
    setValidated(true);
  };
  
  return (
    <div>
      <Navegacion title={"Mis Tickets Comprados"} />
      <Container fluid  className="vh-100">
        <Row>
          <Col className="mt-4">
            <h2>Historial de mis compras</h2>
          </Col>
        </Row>
        <Row>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Col xs={12} >
              <Form.Group controlId="validationCustom01">
              <div className="text-start mt-3">
                <Form.Label>Correo electrónico</Form.Label>
              </div>
                <Form.Control
                  required
                  type="email"
                  placeholder="Ejemplo@correo.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <Form.Control.Feedback type="invalid">
                  Por favor, digita un correo válido.
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Button type="submit" variant="dark">Consultar</Button>
        </Form>
        </Row>

        {error && (
          <Alert variant="danger" className="mt-3">
            {error}
          </Alert>
        )}

        {compras.length > 0 && (
          <>
            <Alert variant="info" className="mt-3">
              Se encontraron compras en {compras.length} dinamicas.
            </Alert>
            {compras.map((compra) => (
              <CardMisCodigos
                key={compra.sorteoId} // Usa el ID del sorteo como clave
                correo={email}
                titulo={compra.sorteo.title || "Sorteo sin nombre"}
                fecha={compra.tickets.length > 0 ? compra.tickets[0].fecha : "Fecha no disponible"}
                tickets={compra.tickets.map((ticket) => ticket.numero)}
                // Pasar los numeros premiados del sorteo para marcar boletos ganadores
                numerosPremiados={Array.isArray(compra.sorteo.numerosPremiados) ? compra.sorteo.numerosPremiados : []}
              />
            ))}
          </>
        )}
      </Container>
      <Footer />
    </div>
  );
}

export default MisCodigos;
